import { render, staticRenderFns } from "./new-profile.vue?vue&type=template&id=e67d8b94&"
import script from "./new-profile.vue?vue&type=script&lang=js&"
export * from "./new-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports